import axios from "axios";
import { toast } from "react-toastify";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_BACKEND_URL || "https://api.acheseupintor.com.br/",
});

api.interceptors.request.use(function (config) {
  if (!config.headers["Authorization"]) {
    const authData = localStorage.getItem("_auth");
    if (authData) {
      try {
        const parsed = JSON.parse(authData);
        const token = parsed?.auth?.token || parsed?.token;
        if (token) {
          config.headers["Authorization"] = "Bearer " + token;
        }
      } catch (e) {
        const token = authData;
        config.headers["Authorization"] = "Bearer " + token;
      }
    }
  }
  return config;
});

api.interceptors.response.use(
  function (response) {
    if (response?.data) toast.success(response?.data?.message);

    return response;
  },
  async function (error) {
    if (error.response?.data) {
      const data = error.response.data;
      const msg = data.message;
      const messageText = Array.isArray(msg) ? msg[0] : msg;
      toast.error(messageText);
      return data;
    } else {
      return { message: "Error no servidor." };
    }
  }
);

export default api;
